import { domain } from "../../constants/generalConstant";
import { FaCalendarAlt } from "react-icons/fa";
import { HiDocumentCheck } from "react-icons/hi2";
import { IoBusiness } from "react-icons/io5";
// import grl from "../../assets/grl.jpg";
import docsparcel from "../../assets/whoweare.jpg";
import cargoshipping from "../../assets/whoweare2.jpg";
import sustain from "../../assets/girlshipper.jpg";
import shipatlas from "../../assets/shipatlas.jpg";
import { RiFlightTakeoffLine } from "react-icons/ri";
import { MdOutlineImportExport } from "react-icons/md";
import { CgOptions } from "react-icons/cg";
import { FaTruckFast } from "react-icons/fa6";
import { GiCargoShip } from "react-icons/gi";
import { MdOutlineDirectionsRailway } from "react-icons/md";
import whoweare from "../../assets/aboutus3.jpg";
import wapart from "../../assets/wapart4.jpg";

// import container from "../../assets/containers.jpg";

export const OneData = [
  {
    title: "Ship Now",
    subTitle: "Find the right service",
    url: "",
    icon: <FaCalendarAlt />,
    id: 1,
  },
  {
    title: "Get a Quote",
    subTitle: "Estimate cost to share and compare",
    url: "",

    icon: <HiDocumentCheck />,
    id: 2,
  },
  {
    title: `${domain} for business`,
    subTitle:
      "Shipping regularly? Request a business account and profit from exclusive benefits",
    url: "",

    icon: <IoBusiness />,
    id: 3,
  },
];

export const twoData = [
  {
    title: "About Us",
    subTitle: "Our story",
    description: `
        
        Founded with a mission to connect businesses and individuals with swift, secure, and affordable shipping solutions, we take pride in delivering excellence every step of the way.
        
        
       
        
        `,
    imgUrl: docsparcel,
    serviceLink: "",
    serviceLinkTitle: `Explore ${domain} Express`,
    id: 1,
    subData: [
      {
        title: "Flexible Import/Export Options",
        icon: <MdOutlineImportExport />,
        id: 1,
      },
      {
        title: "Tailored Business Solutions",
        icon: <IoBusiness />,
        id: 2,
      },
      {
        title: "Next Possible Business Day",
        icon: <RiFlightTakeoffLine />,
        id: 3,
      },
      {
        title: "Wide Variety of Optional Services",
        icon: <CgOptions />,
        id: 4,
      },
    ],
  },
  {
    title: "Who we are",
    subTitle: "The inside story",
    description: `
        
        Our team is dedicated to providing a seamless courier experience, leveraging cutting-edge technology and a vast network of logistics partners to ensure your packages reach their destination on time, every time.
        
        `,
    imgUrl: whoweare,
    serviceLink: "",
    serviceLinkTitle: `Explore ${domain} Global Forwarding`,
    id: 2,
    subData: [
      {
        title: "Ocean Freight",
        icon: <GiCargoShip />,
        id: 1,
      },
      {
        title: "Road Freight",
        icon: <FaTruckFast />,
        id: 2,
      },
      {
        title: "Rail Freight",
        icon: <MdOutlineDirectionsRailway />,
        id: 3,
      },
      {
        title: "Air Freight",
        icon: <RiFlightTakeoffLine />,
        id: 4,
      },
    ],
  },

  {
    title: "Our mission",
    subTitle: "It's beyound the usual.",
    description: `
        
Our mission is to simplify the courier process by offering transparent, dependable, and cost-effective shipping options tailored to your needs. We aim to build lasting relationships with our clients by prioritizing trust, safety, and customer satisfaction.


        
        `,
    imgUrl: cargoshipping,
    serviceLink: "",
    serviceLinkTitle: `Explore ${domain} Global Forwarding`,
    id: 2,
    subData: [
      {
        title: "Ocean Freight",
        icon: <GiCargoShip />,
        id: 1,
      },
      {
        title: "Road Freight",
        icon: <FaTruckFast />,
        id: 2,
      },
      {
        title: "Rail Freight",
        icon: <MdOutlineDirectionsRailway />,
        id: 3,
      },
      {
        title: "Air Freight",
        icon: <RiFlightTakeoffLine />,
        id: 4,
      },
    ],
  },

  {
    title: "What sets us apart",
    subTitle: "It's beyound the usual.",
    description: `
We have unique approach in place to ensure your package gets to you at the right time.  
         

        `,
    imgUrl: wapart,
    serviceLink: "",
    serviceLinkTitle: `Explore ${domain} Global Forwarding`,
    id: 2,
    subData: [
      {
        title: "Reliable Service",
        icon: <GiCargoShip />,
        id: 1,
      },
      {
        title: "Wide Network",
        icon: <FaTruckFast />,
        id: 2,
      },
      {
        title: "Customer-Centric",
        icon: <MdOutlineDirectionsRailway />,
        id: 3,
      },
      {
        title: "Advanced Technology",
        icon: <RiFlightTakeoffLine />,
        id: 4,
      },
    ],
  },
];

export const thirdData = [
  {
    title: "Sustainability",
    imgUrl: sustain,
    description:
      "Sustainable business begins with sustainable supply chains. We proudly provide a comprehensive portfolio of emission reduced logistics solutions. Find out what we have to offer, why we're committed to sustainability, and how our industry is helping deliver an even better world.",
    id: 1,
  },
  {
    title: `${domain} Trade Atlas 2025`,
    imgUrl: shipatlas,
    description:
      "Global trade recovered in 2024 and is forecast to grow faster over the next five years than during the preceding decade ",
    id: 2,
  },
];
